import { Outlet } from "react-router"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"
import { TabContent, Tabs, TabsList } from "@sembark-travel/ui/base"
import { generatePath } from "../../../../router-utils"
import { NavLink } from "@sembark-travel/ui/router"

export default function Layout() {
	return (
		<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_ACCOUNTING}>
			<Tabs layout="col">
				<TabsList>
					<NavLink to={generatePath("/payments/gateway/transactions")}>
						Transactions
					</NavLink>
					<NavLink to={generatePath("/payments/gateway/settlements")}>
						Settlements
					</NavLink>
				</TabsList>
				<TabContent>
					<Outlet />
				</TabContent>
			</Tabs>
		</ForbidUnlessAuthorized>
	)
}
